import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { CartNotEmptyGuard, CheckoutAuthGuard } from '@spartacus/checkout/base/components';
import { CmsConfig, DeferLoadingStrategy, I18nModule, provideConfig } from '@spartacus/core';
import { CartSharedModule } from '../../cart/cart-shared/cart-shared.module';
import { MyAccountPermissionsAuthGuard } from '../../myaccount/guards/myaccount-permissions-auth.guard';
import { CheckoutCartIsValidatedGuard } from '../guards/checkout-cart-validated-guard';
import { ShimanoCheckoutDeliveryModeComponent } from './checkout-delivery-mode.component';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    ReactiveFormsModule,
    MatIconModule,
    MatSelectModule,
    CartSharedModule,
    ShimanoCheckoutDeliveryModeComponent,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CheckoutDeliveryMode: {
          component: ShimanoCheckoutDeliveryModeComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
          guards: [CheckoutAuthGuard, CartNotEmptyGuard, CheckoutCartIsValidatedGuard, MyAccountPermissionsAuthGuard],
        },
      },
    }),
  ],
  exports: [ShimanoCheckoutDeliveryModeComponent],
})
export class CheckoutDeliveryModeModule {}
